import { render } from "./loading-dots.vue?vue&type=template&id=26b3bca6"
const script = {}

import exportComponent from "../../../../../../../../../dow-corp/ui.frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__